import {
    CONTROL_KITCHEN_ROUTE,
    MERCHANT_PRODUCTION_ROUTE,
    MERCHANT_PRODUCTION_PLANNING_ROUTE,
    MERCHANT_PRODUCTION_TRANSACTIONS_ROUTE,
    MERCHANT_REPORTS_ROUTE,
    SURVEY_ROUTE,
    MERCHANT_REPORTS_MENU_PLANNING_ROUTE,
    MERCHANT_PRODUCTION_MEETING_SERVICE_ROUTE,
} from "../../../../constants/routes"
import { faHome, faCheckToSlot, faUtensils, faShieldCheck, faFaceSmile } from "@fortawesome/pro-light-svg-icons"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import { NavMenuItem } from "../../../../shared/layouts/components/NavMenuItem"
import { MatchEnvironment } from "../../../environment/components/MatchEnvironment"
import { EnvironmentType } from "../../../environment/envTypes"
import { NavMenuItemGroupWrapper, NavMenuSubItem } from "../../../../shared/layouts/components/NavMenuItemGroup"

type Props = Readonly<{}>

export function MerchantReportNavItems({}: Props) {
    return (
        <>
            <LocalizedStrict id="merchant-nav-item-home">
                <NavMenuItem icon={faHome} dest={MERCHANT_REPORTS_ROUTE}>
                    Home
                </NavMenuItem>
            </LocalizedStrict>

            <LocalizedStrict id="merchant-nav-item-production" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper icon={faCheckToSlot} dest={MERCHANT_PRODUCTION_ROUTE} title="Production">
                    <LocalizedStrict id="merchant-nav-item-production-planning">
                        <NavMenuSubItem route={MERCHANT_PRODUCTION_PLANNING_ROUTE}>Planning</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="merchant-nav-item-production-meeting-service">
                        <NavMenuSubItem route={MERCHANT_PRODUCTION_MEETING_SERVICE_ROUTE}>
                            Meeting service
                        </NavMenuSubItem>
                    </LocalizedStrict>
                    <MatchEnvironment
                        environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo]}
                    >
                        <LocalizedStrict id="merchant-nav-item-production-order-flow">
                            <NavMenuSubItem route={"TODO"}>OrderFlow</NavMenuSubItem>
                        </LocalizedStrict>
                    </MatchEnvironment>
                    <LocalizedStrict id="merchant-nav-item-production-transactions">
                        <NavMenuSubItem route={MERCHANT_PRODUCTION_TRANSACTIONS_ROUTE}>POS transactions</NavMenuSubItem>
                    </LocalizedStrict>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>

            <LocalizedStrict id="merchant-nav-item-menu-planning">
                <NavMenuItem icon={faUtensils} dest={MERCHANT_REPORTS_MENU_PLANNING_ROUTE}>
                    Menu Planning
                </NavMenuItem>
            </LocalizedStrict>

            <LocalizedStrict id="merchant-nav-item-purchase-control">
                <NavMenuItem icon={faShieldCheck} dest={CONTROL_KITCHEN_ROUTE}>
                    Purchase Control
                </NavMenuItem>
            </LocalizedStrict>

            <LocalizedStrict id="merchant-nav-item-survey">
                <NavMenuItem icon={faFaceSmile} dest={SURVEY_ROUTE}>
                    Survey
                </NavMenuItem>
            </LocalizedStrict>
        </>
    )
}
